// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"302":"3f8d24a5","408":"26e29658","487":"254291e9","879":"703f7a05","967":"d97b82e3"}[chunkId] + ".chunk.css";
};